import React from "react";
import { useSelector } from "react-redux";
import { getComponentUserStatus, getToolsCount } from "../store/tools";

export default function ToolList(props) {
    const { handleToolShowHide, compList, activeToolId } = props;
    const toolsCountSelector = useSelector(getToolsCount);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);

    const getCount = (id) => {
        if (!toolsCountSelector) return 0;
        const toolObj = toolsCountSelector?.filter(x => x.key === id);
        if (toolObj?.length > 0) return toolObj[0].value;
        return 0;
    };

    const getBadge = (id) => {
        const compObj = (componentUserStatusSelector || []).filter(x => x.compId === id);
        if (compObj.length > 0) {
            const unreadComps = String(compObj[0].unreadCompItems || "").split(',').sort();
            const readComps = String(compObj[0].compItems || "").split(',').sort();
            let unReadCount = 0;
            unreadComps.filter(x => x !== "").forEach(x => {
                const rs = readComps.filter(y => y === x);
                if (rs.length === 0) {
                    unReadCount += 1;
                }
            });

            if (unReadCount === 0) {
                const count = getCount(id);
                if (count === 0) return null;
                return (
                    <span className="rt-tool-card-badge is-read">
                        {count}
                    </span>
                );
            } else {
                return (
                    <span className="rt-tool-card-badge is-unread">
                        {unReadCount}
                    </span>
                );
            }
        } else {
            const count = getCount(id);
            if (count === 0) return null;
            return (
                <span className="rt-tool-card-badge is-unread">
                    {count}
                </span>
            );
        }
    };

    const getUnreadCount = (id) => {
        const compObj = (componentUserStatusSelector || []).filter(x => x.compId === id);
        if (compObj.length === 0) return getCount(id);

        const unreadComps = String(compObj[0].unreadCompItems || "").split(',').sort();
        const readComps = String(compObj[0].compItems || "").split(',').sort();
        let unReadCount = 0;

        unreadComps.filter(x => x !== "").forEach(x => {
            const rs = readComps.filter(y => y === x);
            if (rs.length === 0) {
                unReadCount += 1;
            }
        });

        return unReadCount;
    };

    const getToolTheme = (id) => {
        switch (id) {
            case 9: return "messages";
            case 10: return "phone";
            case 11: return "schedule";
            case 18: return "forms";
            case 24: return "templates";
            case 49: return "reports";
            default: return "default";
        }
    };

    const getToolIcon = (id) => {
        switch (id) {
            case 9: return "fa-comments-o";
            case 10: return "fa-phone";
            case 11: return "fa-calendar";
            case 18: return "fa-list-alt";
            case 24: return "fa-clone";
            case 49: return "fa-file-word-o";
            default: return "fa-wrench";
        }
    };

    const getToolMeta = (id) => {
        const count = getCount(id);
        const unreadCount = getUnreadCount(id);

        if (unreadCount > 0) return `${unreadCount} unread`;
        if (count > 0) return `${count} item${count === 1 ? "" : "s"}`;
        return "Ready";
    };

    if (!compList || compList.length === 0) {
        return (
            <div className="rt-tools-empty">
                <div className="rt-tools-empty-icon">
                    <i className="fa fa-wrench" aria-hidden="true" />
                </div>
                <div>
                    <p className="rt-tools-empty-title">No review tools available</p>
                    <p className="rt-tools-empty-desc">Tools will appear here when enabled for this task.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="rt-tools-grid">
            {compList.map((r) => {
                const isActive = activeToolId === r.id;
                const theme = getToolTheme(r.id);
                const icon = getToolIcon(r.id);
                const meta = getToolMeta(r.id);

                return (
                    <button
                        type="button"
                        key={r.id}
                        className={`rt-tool-card ${isActive ? "active" : ""}`}
                        data-theme={theme}
                        onClick={() => handleToolShowHide(r.id, "")}
                        title={r.name}
                    >
                        <div className="rt-tool-card-icon-box">
                            <i className={`fa ${icon}`} aria-hidden="true" />
                        </div>
                        <div className="rt-tool-card-info">
                            <p className="rt-tool-card-name">{r.name}</p>
                            <span className="rt-tool-card-meta">{meta}</span>
                        </div>
                        {getBadge(r.id)}
                        <i className="fa fa-angle-right rt-tool-card-arrow" aria-hidden="true" />
                    </button>
                );
            })}
        </div>
    );
}
